import classnames from "classnames"
import React from "react"

const ToolbarSpacer = ({ className }) => (
  <div className={classnames("toolbar-spacer", className)} />
)

export default ToolbarSpacer
